<template>
    <div class="container container-fluid">
        <h1 class="page-heading mb-0">Clinical Trial Table/Component</h1>

        <clinical-trial-component :trial-content="clinicalTrialDemoData1">
            <!-- Clinical results template -->
            <template slot="results">
                <div class="clinical-trial__text-block px-md-2">
                    <!-- Sitecore content from Rich Text Editor -->
                    <div class="row-description">
                        <strong>Results</strong>
                    </div>
                    <span class="row-description ">
                        <p>
                            Major CVD events and total invasive cancer were not
                            significantly reduced by Omega-3 or vitamin D3.
                            Omega-3 significantly reduced total MI, especially
                            in African Americans and those with lower fish
                            intake.
                        </p>
                        <br/>
                    </span>
                    <!-- End Sitecore -->
                </div>
            </template>
            <!-- End template -->
        </clinical-trial-component>
    </div>
</template>

<script>
export default {
    data() {
        return {
            clinicalTrialDemoData1: {
                active: false, // needs to be false by default
                table: {
                    sidebarContent: [
                        {
                            title: "<strong>Purpose</strong>",
                            content: `<p>To study the primary prevention role daily supplements of vitamin D3 or omega-3 fatty acids in reducing the risk of developing cancer, heart disease, and stroke in people with no history of cancer, heart disease or stroke.</p>`
                        },
                        {
                            title: "<strong>Trail Design</strong>",
                            content: `<p>25,871 U.S. adults (men ≥50; women ≥55); median treatment 5.3 years. Double-blinded, placebo-controlled, randomized, 2x2 factorial: (1) vitamin D3 (cholecalciferol; 2000 IU daily) and marine omega-3 fatty acids (Omacor&reg; fish oil, (eicosapentaenoic acid [EPA] and docosahexaenoic acid [DHA]], 1 g daily); (2) vitamin D and omega-3 placebo; (3) vitamin D placebo and omega-3 fatty acids; (4) both placebo.</p>`
                        },
                        {
                            title: "<strong>Primary Endpoints</strong>",
                            content: `<p>Primary Endpoints: (a) MACE (composite MI, stroke, CVD mortality); (b) total invasive cancer.</p>`
                        }
                    ],
                    rows: [
                        {
                            name: "MACE composite",
                            active: false,
                            colData: [
                                {
                                    titles: ["event", "event"],
                                    names: ["Vit D3", "placebo"],
                                    values: ["396", "409"],
                                    resultsLabel: "events",
                                    result: "HR=0.97"
                                },
                                {
                                    titles: ["event", "event"],
                                    names: ["O3FA", "placebo"],
                                    values: ["386", "419"],
                                    resultsLabel: "events",
                                    result: "8% reduction (HR-0.92); p=0.24"
                                }
                            ]
                        },
                        {
                            name: "Total Invasive Cancer",
                            active: false,
                            colData: [
                                {
                                    titles: ["event", "event"],
                                    names: ["Vit D3", "placebo"],
                                    values: ["793", "824"],
                                    resultsLabel: "events",
                                    result: "HR=0.96"
                                },
                                {
                                    titles: ["event", "event"],
                                    names: ["O3FA", "placebo"],
                                    values: ["820", "797"],
                                    resultsLabel: "events",
                                    result: "No reduction (HR-1.03)"
                                }
                            ]
                        },
                        {
                            name: "Total MI",
                            active: false,
                            colData: [
                                {
                                    titles: ["event", "event"],
                                    names: ["Vit D3", "placebo"],
                                    values: ["169", "176"],
                                    resultsLabel: "events",
                                    result: "HR=0.96"
                                },
                                {
                                    titles: ["event", "event"],
                                    names: ["O3FA", "placebo"],
                                    values: ["145", "200"],
                                    resultsLabel: "events",
                                    result: "28% reduction (HR-0.72, p=0.003)"
                                }
                            ]
                        },
                        {
                            name: "MI African Americans",
                            active: false,
                            colData: [
                                {
                                    titles: [],
                                    names: [],
                                    values: [],
                                    resultsLabel: "",
                                    result: ""
                                },
                                {
                                    titles: ["", "event"],
                                    names: ["O3FA", "placebo"],
                                    values: ["9", "39"],
                                    resultsLabel: "events",
                                    result: "77% reduction (HR-0.23, p=0.001)"
                                }
                            ]
                        }
                    ]
                }
            }
        };
    }
};
</script>



// WEBPACK FOOTER //
// demo/pages/components/phd-clinical-trial-component.vue